import { Link } from "react-router-dom";
import useTitle from "./useTitle";

const NotFound = () => {
    useTitle("搵唔到呢一頁｜Math-EXE");
    return (
        <div className="not-found">
            <h2>Sorry</h2>
            <p>That page cannot be found</p>
            <Link to="/">Back to the home page...</Link>
        </div>
    );
}
 
export default NotFound;